import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  private sidenavOpen = new BehaviorSubject<boolean>(false);
  sidenavOpen$ = this.sidenavOpen.asObservable();
  private btnSidenav = new BehaviorSubject<boolean>(false);
  btnSidenav$ = this.btnSidenav.asObservable();

  constructor() {}

  openSidenav({ valueBtn, valueSide }: { valueSide: boolean; valueBtn: boolean }): void {
    this.sidenavOpen.next(valueSide);
    this.btnSidenav.next(valueBtn);
  }

  // mostrarBtnSidenav(value: boolean): void {
  //   this.btnSidenav.next(value);
  // }
}
